<form [formGroup]="form" *ngIf="form">

  <mat-horizontal-stepper linear #stepper class="createStepper">

    <!-- details -->
    <mat-step [stepControl]="form">
      <ng-template matStepLabel>
        <span fxHide.lt-lg="true">
          Firmenname
        </span>
      </ng-template>

      <div fxLayout="column" fxLayoutGap="20px">

        <div fxFlex="100" fxLayout="column" fxLayoutGap="20px" fxLayoutGap.gt-md="0px">

          <p class="business-label">
            <ng-container *ngIf="showLogoStep; else businessLabelForOthers">
              Gib hier deine Daten an:
            </ng-container>

            <ng-template #businessLabelForOthers>
              Erstelle hier dein Unternehmensprofil. Um mit deinem Unternehmensprofil
              Beiträge erstellen zu können, brauchst Du Credits. Diese kannst Du hinzubuchen.
              Mit Veröffentlichung des Unternehmensprofil sendest Du eine unverbindliche
              Anfrage an unser Team. Wir melden uns dann zeitnah für ein kostenloses
              Beratungsgespräch.
            </ng-template>
          </p>

          <!-- type_definition - only for OTHER-->
          <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px"
            *ngIf="user.company_profile.type=='OTHER'">
            <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Art</div>
            <div fxFlex="85">

              <mat-form-field>
                <mat-select formControlName="type_definition" placeholder="Art"
                  (selectionChange)="updateDraft('type_definition')">
                  <mat-option *ngFor="let t of companyprofile_type_definition_array" [value]="t">
                    {{ t | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-error
                *ngIf="(form.get('type_definition').touched || submitted) && form.hasError('type_definition_required')">
                *Art ist ein Pflichtfeld
              </mat-error>
            </div>
          </div>

          <!-- type_sector - only for OTHER-->
          <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px"
            *ngIf="user.company_profile.type=='OTHER'">
            <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Branche</div>
            <div fxFlex="85">

              <mat-form-field>
                <mat-select formControlName="type_sector" placeholder="Branche"
                  (selectionChange)="updateDraft('type_sector')">
                  <mat-option *ngFor="let t of companyprofile_type_sector_array" [value]="t">
                    {{ t | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-error *ngIf="(form.get('type_sector').touched || submitted) && 
              form.hasError('type_sector_required')">
                *Branche ist ein Pflichtfeld
              </mat-error>
            </div>
          </div>

          <!-- Company Name -->
          <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
            <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Firmenname</div>
            <div fxFlex="60" fxLayout="column">
              <mat-form-field fxFlex="grow">
                <input matInput type="text" formControlName="name" placeholder="Firmenname"
                  (blur)="updateDraft('name')" />
              </mat-form-field>

              <mat-error *ngIf="(form.get('name').touched || submitted) && form.get('name').errors">
                {{messages.companyNameInvalid}}
              </mat-error>
            </div>
          </div>

          <!-- PLZ / City -->
          <div class="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">PLZ, Ort</div>
            <div fxFlex="60" fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">

              <div fxFlex>

                <!-- old @angular-material-extensions/google-maps-autocomplete autocomplete -->
                <!-- <mat-form-field >
                  <input matInput formControlName="zip"
                  matGoogleMapsAutocomplete
                  placeholder="PLZ"
                  country="de,ch,at"
                  type="number"
                  [types]="['geocode']"
                  [country]="['de','at','ch']"
                  (onAutocompleteSelected)="onAutocompleteSelected($event)"
                  (blur)="updateDraft('zip')">
                </mat-form-field> -->

                <!-- FIELDs WITHOUT GOOGLE COMPLETION -->
                <mat-form-field>
                  <input matInput type="text" formControlName="zip" placeholder="PLZ" (blur)="updateDraft('zip')" />
                </mat-form-field>

                <mat-error *ngIf="(form.get('zip').touched || submitted) && form.get('zip').hasError('required')">
                  *PLZ ist ein Pflichtfeld
                </mat-error>
              </div>

              <div fxFlex>
                <mat-form-field>
                  <input matInput type="text" formControlName="city" placeholder="Ort" (blur)="updateDraft('city')" />
                </mat-form-field>

                <mat-error *ngIf="(form.get('city').touched || submitted) && form.get('city').hasError('required')">
                  *Ort ist ein Pflichtfeld
                </mat-error>
              </div>
            </div>
          </div>

          <!-- Straße, Nr -->
          <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
            <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Straße, Nr.</div>
            <div fxFlex="60" fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">

              <div fxFlex>
                <mat-form-field>
                  <input matInput type="text" formControlName="street" placeholder="Straße"
                    (blur)="updateDraft('street')" />
                </mat-form-field>
                <mat-error *ngIf="(form.get('street').touched || submitted) && form.get('street').hasError('required')">
                  *Straße ist ein Pflichtfeld
                </mat-error>
              </div>

              <div fxFlex>
                <mat-form-field>
                  <input matInput type="text" formControlName="street_additional" placeholder="Nr"
                    (blur)="updateDraft('street_additional')" />
                </mat-form-field>

                <mat-error
                  *ngIf="(form.get('street_additional').touched || submitted) && form.get('street_additional').hasError('required')">
                  *Nummer ist ein Pflichtfeld
                </mat-error>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="10px" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="end center">
        <!-- <button (click)="discard()" class="mobileGrowBtn">Verwerfen</button> -->
        <button class="orange-button mobileGrowBtn" (click)="nextIfValid()">Weiter</button>
      </div>

    </mat-step>

    <!-- contact -->
    <mat-step [stepControl]="form">
      <ng-template matStepLabel>
        <span fxHide.lt-lg="true">
          Kontakt
        </span>
      </ng-template>

      <p class="business-label">Wer ist der Ansprechpartner und wie sind die Kontaktdaten?</p>

      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
        <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Ansprechpartner</div>
        <div fxFlex="60" fxLayout="row" fxLayoutGap="20px">

          <div fxFlex>
            <mat-form-field>
              <input matInput type="text" formControlName="contact_name" (blur)="updateDraft('contact_name')" />
            </mat-form-field>
          </div>

        </div>
      </div>

      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
        <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Position</div>
        <div fxFlex="60" fxLayout="row" fxLayoutGap="20px">

          <div fxFlex>
            <mat-form-field>
              <input matInput type="text" formControlName="contact_position" (blur)="updateDraft('contact_position')" />
            </mat-form-field>
          </div>

        </div>
      </div>

      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
        <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Telefon</div>
        <div fxFlex="60" fxLayout="row" fxLayoutGap="20px">

          <div fxFlex>
            <mat-form-field>
              <input matInput type="text" formControlName="telephone" (blur)="updateDraft('telephone')" />
            </mat-form-field>

            <mat-error *ngIf="(form.get('telephone').touched || submitted) && form.get('telephone').errors">
              {{messages.telInvalid}}
            </mat-error>
          </div>

        </div>
      </div>

      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
        <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">E-Mail</div>
        <div fxFlex="60">

          <div fxFlex>
            <mat-form-field>
              <input matInput type="text" formControlName="email" (blur)="updateDraft('email')" />
            </mat-form-field>

            <mat-error *ngIf="(form.get('email').touched || submitted) && form.get('email').errors">
              {{messages.emailInvalid}}
            </mat-error>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="20px">
        <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center">Webseite</div>
        <div fxFlex="60">

          <div fxFlex>
            <mat-form-field>
              <input matInput type="text" formControlName="website" (blur)="updateDraft('website')" />
            </mat-form-field>

            <mat-error *ngIf="(form.get('website').touched || submitted) && form.get('website').errors">
              *Die Webseite muss einem gültigen Format entsprechen
            </mat-error>
          </div>
        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="10px" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="end center">
        <!-- <button class="mobileGrowBtn" (click)="discard()">Verwerfen</button> -->
        <button class="dark-grey-button mobileGrowBtn" matStepperPrevious>Zurück</button>
        <button class="orange-button mobileGrowBtn" (click)="nextIfValid()">Weiter</button>
      </div>

    </mat-step>

    <!-- images -->
    <mat-step *ngIf="showLogoStep" [stepControl]="form">
      <ng-template matStepLabel>
        <span fxHide.lt-lg="true">
          Logo/ Titelbild
        </span>
      </ng-template>

      <p class="business-label">Lade hier dein Logo und dein Titelbild hoch:</p>

      <div fxLayout="column" fxLayoutGap="20px">

        <!-- logo -->
        <p class="business-label">Logo</p>

        <div fxLayout="row" fxLayoutAlign="start start">

          <edit-images *ngIf="user.company_profile.profileImage" [images]="[user.company_profile.profileImage]"
            [deleteImage]="deleteImage.bind(this)" [key]="'COMPANY_IMAGE'">
          </edit-images>

          <image-upload-box *ngIf="!user.company_profile.profileImage" [fileSelected]="fileSelected.bind(this)"
            [fileDropped]="fileDropped.bind(this)" [key]="'COMPANY_IMAGE'" [multiple]="false" [singular]="'Logo'">
          </image-upload-box>

        </div>

        <!-- wall image -->
        <p class="business-label">Titelbild</p>

        <div fxLayout="row" fxLayoutAlign="start start">

          <edit-images *ngIf="user.company_profile.profileWallImage" [images]="[user.company_profile.profileWallImage]"
            [deleteImage]="deleteImage.bind(this)" [key]="'COMPANY_WALL_IMAGE'"></edit-images>

          <image-upload-box *ngIf="!user.company_profile.profileWallImage" [fileSelected]="fileSelected.bind(this)"
            [fileDropped]="fileDropped.bind(this)" [key]="'COMPANY_WALL_IMAGE'" [multiple]="false"
            [singular]="'Titelbild'">
          </image-upload-box>

        </div>

        <div fxLayout="column" fxLayoutGap="10px" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="end center">
          <!-- <button class="mobileGrowBtn" (click)="discard()">Verwerfen</button> -->
          <button class="dark-grey-button mobileGrowBtn" matStepperPrevious>Zurück</button>
          <button class="orange-button mobileGrowBtn" (click)="nextIfValid()">Weiter</button>
        </div>
      </div>
    </mat-step>

    <!-- publish -->
    <mat-step [stepControl]="form">
      <ng-template matStepLabel>
        <span fxHide.lt-lg="true">
          Profil veröffentlichen
        </span>
      </ng-template>

      <div style="text-align: center; padding: 30px;" class="business-label">

        <ng-container *ngIf="showLogoStep; else finalTextForOthers">
          Beginne jetzt gleich dein Unternehmensprofil auszufüllen um das
          Interesse der Community oder von Bewerbern zu wecken.
        </ng-container>

        <ng-template #finalTextForOthers>
          Veröffentliche jetzt dein Unternehmensprofil. Im nächsten Schritt
          kannst Du dein Unternehmensprofil bearbeiten und jederzeit
          ändern.<br>
          Mit Veröffentlichung des Unternehmensprofil sendest Du
          eine unverbindliche Anfrage um Beiträge auf Zimmerer-Treffpunkt
          erstellen zu können.<br>
          Wir melden uns dann zeitnah für ein
          kostenloses Beratungsgespräch.
        </ng-template>
      </div>

      <div fxLayout="column" fxLayoutGap="10px" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="end center">
        <!-- <button class="mobileGrowBtn" (click)="discard()">Verwerfen</button> -->
        <button class="dark-grey-button mobileGrowBtn" matStepperPrevious>Zurück</button>
        <button class="orange-button mobileGrowBtn" (click)="publishCompanyProfile()">
          Veröffentlichen
        </button>
      </div>
    </mat-step>

  </mat-horizontal-stepper>
</form>